import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { FeatureCode, ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subscription } from 'rxjs';
import { Features } from '../../../business-entities/user-role-view-model';
import { CustomerService } from '../../../business-services/customer.service';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { CustomerSendNotificationComponent } from './customer-send-notification/customer-send-notification.component';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CallDialRequestModel } from '../../../business-entities/call-request-model';
import { CallerService } from '../../../business-services/caller.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';

const CustomerTabs: { id: number, label: string, route: string }[] = [
  { id: 1, label: 'lblCustomerDetails', route: 'details' },
  { id: 2, label: 'lblVehicleDetails', route: 'vehicles' },
  { id: 3, label: 'lblCommunication', route: 'communication' },
  { id: 4, label: 'lblCallHistory', route: 'call-history' },
  { id: 5, label: 'lblUpdates', route: 'customer-history' },
]

@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html'
})
export class ViewCustomerComponent implements OnInit {
  noOfTabLimit: number = 1; // ADDED
  selectedtab: number = 1;
  tabs: { id: number, label: string, route: string }[] = CustomerTabs;
  customerId: number;
  contactId: string;
  customerNo: string;
  customerName: string;
  firstName:string;
  lastName:string;
  features: Features[] = [];
  allowQuickSearch:boolean;
  subscription : Subscription;
  IsDMS:boolean;
  dialNumber: string;
  callFromNumber: string;
  customerMobileNo: string;
  isCdssUser: boolean;
  @Input() customerDetails: any;
  @Input() isFromServiceAdvisor: boolean;
  @Input() fromVehicleScreen: boolean;
  @Input() fromVehicleCustomerDetails:boolean =false;
  @Input() preferredDealerId: string = '';
  @Input() isAddNewVehile: boolean = false;

  constructor(
    private readonly activeModal: NgbActiveModal
    ,private readonly serviceBusinessService: VehicleBusinessService
    , private readonly service: CustomerService
    ,private readonly modalService: NgbModal
    ,private readonly currentLanguageService: CurrentLanguage
    ,private readonly secureStorage: SecureStorage
    ,private readonly translate: TranslateService
    ,private readonly toaster: ToastrService
    ,private readonly callerService: CallerService
    ,private readonly cultureLocaleService: CultureLocaleService
    ,private readonly userService: UserDataService
    ,private readonly spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.customerId = this.isFromServiceAdvisor ? 0 : this.service.customerId;
    this.customerNo = this.service.customerNo;
    this.customerName = this.service.customerName;
    this.customerMobileNo = this.service.customerMobileNo;
    this.firstName = this.service.firstName;
    this.lastName = this.service.lastName;
    this.contactId = this.service.contactId
    if (this.isAddNewVehile) {
      this.selectedtab = 2;
      this.serviceBusinessService.customerId = this.service.customerId;
      this.serviceBusinessService.customerNo = this.service.customerNo;
      this.serviceBusinessService.customerName = this.service.customerName;
      this.serviceBusinessService.contactId = this.service.contactId;
    }
    if (this.customerId) {
      this.noOfTabLimit = 5;
    }
    if (this.fromVehicleCustomerDetails) {
      this.noOfTabLimit = 1;
    }
    if (this.userService?.currentUserValue?.userRoleMenuDetails?.find(x => x.moduleId === ModuleNames.IncomingAndOutgoingCalls)?.canView) {
      this.isCdssUser = true;
      this.GetCallFromNumber();
    }
  }
  get getUserObj()
  {
    return this.secureStorage.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
  }
  OnClose() {
    this.activeModal.close({ success: true });
    this.service.customerDetail = null;
  }

  tabSelected(id) {
    this.selectedtab = id;
    if(id == 2){
      this.serviceBusinessService.customerId = this.service.customerId;
      this.serviceBusinessService.customerNo = this.service.customerNo;
      this.serviceBusinessService.customerName = this.service.customerName;
      this.serviceBusinessService.contactId = this.service.contactId;
      this.firstName = this.service.firstName;
      this.lastName = this.service.lastName;
    }
  }

  showVehileAndOtherDetailsTabsFn(_e) {
    this.noOfTabLimit = 5;
    this.selectedtab = 2;
  }
  backToFirstTab() {
    this.selectedtab = 1;
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features == null || this.features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        this.features = res;
        this.allowQuickSearch = this.features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
        this.IsDMS = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
      })
    }else{
      this.allowQuickSearch = this.features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
      this.IsDMS = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
    }
  }
  //#region Send Notification
  OpenSendNotificationModel(): void {
    const modalref = this.modalService.open(CustomerSendNotificationComponent, { size: 'lg', windowClass: 'pop-wid1200' });
    modalref.componentInstance.customerDetails = this.service.customerDetail;
  }
  //#endregion
  //#region Call Methods
  GetCallFromNumber(){
    this.spinner.show();
    this.cultureLocaleService.globalSettingValues.subscribe((response) => {
      let result = response.find(x => x.property === "CallFromNumber");
      this.spinner.hide();
      if (result && !result?.value) {
        if (result.value == 'FROM_USER') {
          this.callFromNumber = this.getUserObj.mobileNo;
        }
        else{
          this.callFromNumber = result.value;
        }
      }
    });
  }

  DialCall(dialContent){
    this.dialNumber = this.customerMobileNo;
    const modalRef = this.modalService.open(dialContent, {ariaLabelledBy: 'modal-basic-title', size: 'md'})
    modalRef.result.then(
      (_result) => {
        // This is intentional
       },
      (reason) => {
        if (reason) {
          this.InitiateCall(modalRef)
        }
      });
  }

  InitiateCall(modalRef){
    let errorMsg = this.translate.instant('lblErrormsgs');
    let failedMsg = this.translate.instant('lblDialFailed');
    let successMsg = this.translate.instant('lblDialSuccess');
    if (this.dialNumber) {
      let model: CallDialRequestModel = {
        Number: this.getUserObj.mobileNo,
        CustomerId: 0,
        DestinationNumber: this.dialNumber,
        CallerId: this.callFromNumber
      }
      this.spinner.show();
      this.callerService.callDial(model).then((response) => {
        let result = response.responseObject;
        this.spinner.hide();
        if (result && !result?.error) {
          this.toaster.success(successMsg);
          this.dialNumber = "";
          modalRef.close();
        } else {
          this.toaster.error(failedMsg);
        }
      }).catch((_err)=>{
        this.spinner.hide();
        this.toaster.error(errorMsg);
      }).finally(()=>{
        this.spinner.hide();
      });
    }
  }
  //#endregion
}
